/** Maps legacy trin ids through V3.1 and V3.2 curriculum changes. */

import { migrateTrinIdV32 } from './migrateV32';

export function migrateTrinId(id: string): string {
  let cur = id;
  if (cur === 'grundniveau-trin-7') cur = 'niveau-1-trin-1';
  const m = /^niveau-1-trin-(\d+)$/.exec(cur);
  if (m) {
    const n = Number(m[1]);
    if (n >= 1 && n <= 14) cur = `niveau-1-trin-${n + 1}`;
  }
  return migrateTrinIdV32(cur);
}

export function migrateTrinIdList(ids: string[]): string[] {
  const out = new Set<string>();
  for (const id of ids) out.add(migrateTrinId(id));
  return [...out];
}
